webpackJsonp([274226809838094],{

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/register-now-left.60803bbf.svg";

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/seo-2.6b5b70df.svg";

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pakistan_character_seo.c4ced30f.svg";

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(9);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(50);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(49);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _pakistan_character_seo = __webpack_require__(69);
	
	var _pakistan_character_seo2 = _interopRequireDefault(_pakistan_character_seo);
	
	var _seo = __webpack_require__(68);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _registerNowLeft = __webpack_require__(67);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _cover = __webpack_require__(91);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Seo = function (_React$Component) {
		(0, _inherits3.default)(Seo, _React$Component);
	
		function Seo() {
			(0, _classCallCheck3.default)(this, Seo);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Seo.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Seo.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
		};
	
		Seo.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Writing Jobs From Home. Part time jobs Pakistan.UvoCorp.com - Pakistan.UvoCorp.com",
					meta: [{ name: "description", content: "Work at home jobs for freelance writers. Good writing job for English native speakers at Pakistan.UvoCorp.com Registration is free" }, { property: 'og:title', content: "Writing Jobs From Home. Part time jobs Pakistan.UvoCorp.com - Pakistan.UvoCorp.com" }, { property: 'og:description', content: "Work at home jobs for freelance writers. Good writing job for English native speakers at Pakistan.UvoCorp.com Registration is free" }, { property: 'og:site_name', content: "Pakistan.UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://pakistan.uvocorp.com/writing_jobs_from_home.html" }, { rel: 'alternate', href: "https://www.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en" }, { rel: 'alternate', href: "https://canada.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ca" }, { rel: 'alternate', href: "https://hongkong.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-hk" }, { rel: 'alternate', href: "https://india.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-in" }, { rel: 'alternate', href: "https://nigeria.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ng" }, { rel: 'alternate', href: "https://pakistan.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-pk" }, { rel: 'alternate', href: "https://philippines.uvocorp.com/writing_jobs_from_home.html", hrefLang: "en-ph" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper subdomen" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "subdomen-header-title" },
								_react2.default.createElement(
									"p",
									null,
									"ACADEMIC WRITING ASSISTANCE AGENCY"
								),
								_react2.default.createElement(
									"h1",
									null,
									"Writing Jobs From Home in Pakistan"
								)
							),
							_react2.default.createElement(
								"a",
								{ href: ("https://uvocorp.com") + "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-benefits home-block hiring-benefits" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"The benefits you enjoy working as a freelance writer:"
							),
							_react2.default.createElement(
								"ul",
								{ className: "home-benefits-list" },
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-1" },
									_react2.default.createElement(
										"p",
										null,
										"No registration fees"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-2" },
									_react2.default.createElement(
										"p",
										null,
										"High wages"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-3" },
									_react2.default.createElement(
										"p",
										null,
										"Working from home"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-4" },
									_react2.default.createElement(
										"p",
										null,
										"Orders in the sphere ",
										_react2.default.createElement("br", null),
										"of your interest"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-5" },
									_react2.default.createElement(
										"p",
										null,
										"24/7 available ",
										_react2.default.createElement("br", null),
										"support team"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-6" },
									_react2.default.createElement(
										"p",
										null,
										"Payments always ",
										_react2.default.createElement("br", null),
										"on time"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-7" },
									_react2.default.createElement(
										"p",
										null,
										"Manage your time ",
										_react2.default.createElement("br", null),
										"and workload yourself"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-pricing-info" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"p",
								null,
								"There is no other company that offers ",
								_react2.default.createElement(
									"strong",
									null,
									"$15"
								),
								"/page written by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ESL"
								),
								" writer and ",
								_react2.default.createElement(
									"strong",
									null,
									"$26"
								),
								"/page completed by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ENL"
								),
								" writer."
							),
							_react2.default.createElement(
								"a",
								{ href: ("https://uvocorp.com") + "/prices.html" },
								"View Pricing ",
								_react2.default.createElement(
									"svg",
									{ id: "arrow-right", width: "22", height: "22" },
									_react2.default.createElement("path", { fill: "#black", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white hiring seo" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								null,
								"Writers wanted"
							),
							_react2.default.createElement(
								"div",
								{ className: "row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-9" },
									_react2.default.createElement(
										"p",
										null,
										"Dear potential ",
										_react2.default.createElement(
											"a",
											{ href: "" + ("https://uvocorp.com") },
											"UVOCORP"
										),
										" writers, we are currently hiring:"
									),
									_react2.default.createElement(
										"ol",
										{ className: "hiring-steps" },
										_react2.default.createElement(
											"li",
											null,
											"Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);"
										),
										_react2.default.createElement(
											"li",
											null,
											"English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;"
										),
										_react2.default.createElement(
											"li",
											null,
											"Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:"
										)
									),
									_react2.default.createElement(
										"ul",
										{ className: "hiring-disciplines" },
										_react2.default.createElement(
											"li",
											{ className: "discipline_8" },
											"Accounting"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_15" },
											"Architecture, Building and Planning"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_14" },
											"Biology (and other Life Sciences)"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_13" },
											"Chemistry"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_1" },
											"Engneering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_10" },
											"Civil Engineering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_7" },
											"Computer Science"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_5" },
											"IT, Web"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_3" },
											"Finance"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_11" },
											"Mathematics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_12" },
											"Physics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_4" },
											"Statistics"
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "hiring-img" },
									_react2.default.createElement("img", { src: _seo2.default, alt: "Seo Image" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "row seo-row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-4 seo-img-container" },
									_react2.default.createElement(
										"div",
										{ className: "seo-img" },
										_react2.default.createElement("img", { src: _pakistan_character_seo2.default, alt: "Seo Image" })
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-md-8" },
									_react2.default.createElement(
										"p",
										null,
										"It is quite unfortunate that, at this point of time, there are companies that will lay off a female working on the grounds that she is pregnant or because she has gotten a baby and, therefore, her services are no longer needed in the workplace. There are so many similar cases in our media. Many women have come out to share their plight with the rest of the world and seek justice, as this has been viewed as sexual discrimination in the workplace. Grace was a victim of this situation. She tells her bitter story but she has a reason to smile because she got a better job online where she gets to work from home."
									),
									_react2.default.createElement(
										"p",
										null,
										"Although Grace has a job, and a better job indeed, she feels that her former boss was not right to fire her on the grounds that she was pregnant. Is being pregnant being incapacitated or does one\u2019s competence disappear when one becomes expectant? She still wants justice and for the boss to understand that it is against human rights to discriminate against any employee on similar grounds. Grace learned about writing jobs from home after a visit with her friend. Grace had already delivered a child and was desperate about how she was to raise the baby without a job. Her friend had been working for a particular online company for quite a while and she knew that Grace would be interested working in the same company, now that she had a baby and had no job. Her friend had to do the application for her and it was time that Grace learned the writing skills so that she could get the job once the application was successful. There were part time jobs and non-part time jobs to choose from, and she chose the part time jobs because she needed time to take care of the young child. Grace is so proud of her current job and so thankful to the ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/", title: "Online Writing Company" },
											"online writing company"
										),
										" for giving her a chance to work as a writer when she desperately needed a job. She feels comfortable with her writing job because no one will discriminate against her and push her to do something she does not like. As long as she does her work correctly and there are no complaints from the clients, she knows that the money is coming and she and her child will lack nothing and they will live happily."
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										"a",
										{ href: ("https://uvocorp.com") + "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Seo;
	}(_react2.default.Component);
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-writing-jobs-from-home-html-js-415b2d6d6952703873b2.js